import { FormikProvider, useFormik } from "formik";
import { IVehicleVisualRecord } from "../../../../../types/vehicle-visual-record.type";
import { useEffect, useState } from "react";
import { VehiclesHistoricalRow } from "../fields-upload/VehiclesHistoricalRow";
import { formatDateAndTime } from "../../../../../common/helpers/date.helpers";

type CardReturnedProps = {
  data: IVehicleVisualRecord;
  onClick?: () => void
  showReturnedDetails?: boolean;
}
export default function CardReturned(props: CardReturnedProps) {
  const [vehicleId, setvehicleId] = useState<string | null>(null);
  const formik = useFormik({
    initialValues: {
      devolutionPhotos: [
        props.data.photos.devolutionPhotos.find(photo => photo.type === 'Traseira do veículo'),
      ] as IVehicleVisualRecord['photos']['devolutionPhotos'],
      // outras propriedades inicializadas aqui
    },
    onSubmit: (values) => { values; },
    // outras opções do Formik aqui
  });

  const endDateAt = props.data.endDateAt ? formatDateAndTime(props.data.endDateAt.toString()) : '';


  useEffect(() => {
    if (props.data !== undefined) { props.data && setvehicleId(vehicleId); }
  }, [props.data, vehicleId]);


  return (
    <FormikProvider value={formik}>
      <div className="flex flex-col items-center bg-gray2/20 m-1 p-1 pt-4 rounded shadow-md border-b border-gray2 cursor-pointer overflow-hidden" onClick={props.onClick}>
        {formik.values?.devolutionPhotos?.map((doc, index) => (
          <div key={index} className={`flex flex-col space-y-2 p-3 my-0 rounded ${index % 2}`}>
            <VehiclesHistoricalRow
              name={`devolutionPhotos.${index}`}
              initialData={doc || {}}
              prefix="devolucao"
              vehicleId={props.data.vehicleId}
            />
          </div>
        ))}

        <p className="text-[.9rem] text-black mx-auto">Devolução</p>
        <p className="text-[.9rem] text-black mx-auto">{endDateAt}</p>
      </div>
    </FormikProvider>
  )
}
